export const environment = {
    clearLocalStorageKey: '1222',
    clearDatabaseKey: '1222',
    isOnline: true,
    version: '1.0.44',
    production: true, // should be true always
    verifyAuth: true, // should be true always
    debug: false, // should be false always
    powerOfOneEnabled: false,
    databaseName: 'route_runner_app',
    domain: 'https://backend.routerunner.co.za/api/mobile/v1',
    sentry: {
        enabled: true,
        dsn: 'https://955993732cf1ba9d89a1378db06cc233@o4511070273273856.ingest.de.sentry.io/4511070705483856',
        appName: 'route-runner-app',
    },
    reverb: {
        broadcaster: 'reverb',
        key: 'ewulmlgzu9rz1seop6kq',
        wsHost: 'ws.backend.routerunner.co.za',
        wsPort: 8080,
        wssPort: 443,
        forceTLS: true,
        enabledTransports: ['ws', 'wss'],
        disableStats: true,
        authEndpoint: 'https://backend.routerunner.co.za/broadcasting/auth',
    },
};
